export default __webpack_public_path__ + "static/media/28.da5e0b94.png";